
import React from 'react';

// import CookieConsent from 'react-cookie-consent';

// import UIUtil from '../../../../modules/UI/util/UIUtil';
import logger from '../../base/app/logger';
import { DialogContainer } from '../../base/dialog';
import { initSlackConsoleLogging } from '../../base/logging/slackLogger';
import MHThemeProvider from '../../base/ui/components/MHThemeProvider';
import { ChromeExtensionBanner } from '../../chrome-extension-banner';

import { AbstractApp } from './AbstractApp';

// Register middlewares and reducers.
import '../middlewares';
import '../reducers';


const SHARE_SCREEN_MP4 = 'images/share-screen.mp4';

/**
 * Preloads the share screen video.
 *
 * @returns {void}
 */
function preloadShareScreenVideo() {
    if (typeof document === 'undefined' || document.querySelector(`link[href="${SHARE_SCREEN_MP4}"]`)) {
        return;
    }

    const doPreload = () => {
        const link = document.createElement('link');

        link.rel = 'prefetch';
        link.href = SHARE_SCREEN_MP4;
        document.head.appendChild(link);
    };

    if ('requestIdleCallback' in window) {
        window.requestIdleCallback(doPreload);
    } else {
        setTimeout(doPreload, 1500);
    }
}

preloadShareScreenVideo();


/**
 * Root app {@code Component} on Web/React.
 *
 * @augments AbstractApp
 */
export class App extends AbstractApp {
    /**
     * Initializes a new App instance.
     *
     * @param {Object} props - The read-only properties with which the new
     * instance is to be initialized.
     */
    constructor(props) {
        super(props);

        // Add global unhandled promise rejection handler
        this._handleUnhandledRejection = this._handleUnhandledRejection.bind(this);
        window.addEventListener('unhandledrejection', this._handleUnhandledRejection);
    }

    /**
     * Handles unhandled promise rejections.
     *
     * @param {PromiseRejectionEvent} event - The unhandled rejection event.
     * @returns {void}
     */
    _handleUnhandledRejection(event) {
        logger.warn('Unhandled promise rejection:', event.reason);

        // Prevent the default behavior (logging to console as error)
        event.preventDefault();
    }

    /**
     * Sets production Slack logging after app initialization.
     *
     * @inheritdoc
     */
    componentDidMount() {
        super.componentDidMount();

        this._init.then(() => {
            const { store } = this.state;

            if (!store || typeof store.getState !== 'function') {
                return;
            }

            const { getState } = store;

            initSlackConsoleLogging(getState, 'web');
        });
    }

    /**
     * Cleanup when component unmounts.
     *
     * @inheritdoc
     */
    componentWillUnmount() {
        super.componentWillUnmount && super.componentWillUnmount();
        window.removeEventListener('unhandledrejection', this._handleUnhandledRejection);
    }

    /**
   * @override
   */
    _createMainElement(component, props) {
        return (
            <MHThemeProvider>
                <>
                    <ChromeExtensionBanner />
                    {super._createMainElement(component, props)}
                </>
            </MHThemeProvider>
        );
    }

    /**
   * Renders the platform specific dialog container.
   *
   * @returns {React$Element}
   */
    _renderDialogContainer() {
        return (
            <>
                {/* <CookieConsent
                    buttonStyle = {{
                        color: '#ffffff',
                        fontSize: '15px',
                        margin: 0,
                        backgroundColor: '#1acc8d'
                    }}
                    buttonText = 'Agree'
                    buttonWrapperClasses = 'cookies-button-wrapper'
                    cookieName = 'meethourCookieConsent'
                    declineButtonStyle = {{
                        fontSize: '13px',
                        margin: 0
                    }}
                    expires = { 150 }
                    location = 'bottom'
                    style = {{
                        background: '#000000',
                        zIndex: '11111111111',
                        alignItems: 'center',
                        textAlign: 'center',
                        justifyContent: 'center'
                    }}>
                    <div
                        style = {{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '5px',
                            justifyContent: 'center'
                        }}>
                        <img
                            alt = 'cookie-image'
                            height = { 30 }
                            src = { 'images/cookies.svg' }
                            width = { 30 } />
                        <p
                            style = {{
                                margin: 0,
                                color: '#fff',
                                fontSize: '16px'
                            }}>
                            {' '}
                        We use cookies in the delivery of our services. By using our
            platform you agree to use of cookies. To know the information about
            privacy policy regarding cookies, please click <a
                                href = '#'
                                onClick = { () => UIUtil.redirect('/privacypolicy') }>Learn More.</a>
                        </p>
                    </div>
                </CookieConsent> */}
                <DialogContainer />
            </>
        );
    }
}

